import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import routes from '../utils/routes';
import strings from '../utils/strings';
import { CButton, CText } from '../components/common';

const Onboarding: React.FC = () => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);
  const [currentStep, setCurrentStep] = useState(0);

  const onboardingData = [
    {
      title: strings.onBoardingTitleText1,
      description: strings.onBoardingDescriptionText1,
    },
    {
      title: strings.onBoardingTitleText2,
      description: strings.onBoardingDescriptionText2,
    },
    {
      title: strings.onBoardingTitleText3,
      description: strings.onBoardingDescriptionText3,
    },
    {
      title: strings.onBoardingTitleText4,
      description: strings.onBoardingDescriptionText4,
    },
  ];

  const handleNext = () => {
    if (currentStep < onboardingData.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      navigate(routes.connect);
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-between min-h-screen"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      {/* Image Placeholder */}
      <div
        className="w-full h-[50vh] flex items-center justify-center rounded-2xl"
        style={{ backgroundColor: colors.inputBackground }}
      >
        <span className="text-5xl" style={{ color: colors.primary }}>📊</span>
      </div>

      {/* Text Content */}
      <div className="w-[90%] px-4 text-left">
        <CText type="B24" className="mt-2">
          {onboardingData[currentStep].title}
        </CText>
        <CText type="R14" color={colors.grayScale500} className="mt-1">
          {onboardingData[currentStep].description}
        </CText>
      </div>

      {/* Dots Indicator */}
      <div className="flex gap-1 ml-4 self-start">
        {onboardingData.map((_, index) => (
          <div
            key={index}
            className={`h-2.5 rounded-full transition-all duration-300 ${
              index === currentStep ? 'w-8' : 'w-2.5'
            }`}
            style={{
              backgroundColor: index === currentStep
                ? colors.primary
                : colors.dark ? colors.grayScale700 : colors.grayScale200,
            }}
          />
        ))}
      </div>

      {/* Button */}
      <div className="w-[90%] mb-5">
        <CButton
          title={currentStep === onboardingData.length - 1 ? strings.getStarted : strings.next}
          onPress={handleNext}
          type="B16"
        />
      </div>
    </div>
  );
};

export default Onboarding;
